export function getSubmitDocumentsButtonText(completedFilesCount: number) {
  if (completedFilesCount === 0) {
    return 'Submit'
  }

  if (completedFilesCount === 1) {
    return `Submit ${completedFilesCount} document`
  }

  return `Submit ${completedFilesCount} documents`
}
